import Alpine from "alpinejs";

Alpine.data("projectTeaser", (url) => ({
    projects: {
        aside: [],
    },
    init() {
        const element = this.$root;
        if (!url) {
            element.remove();
        }
        fetch(url)
            .then((response) => {
                if (!response.ok || response.status >= 300) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                Object.values(data).every((project, index) => {
                    this.projects.aside.push(project);
                    //  Max 3 items
                    return index < 2;
                });
            })
            .catch((e) => {
                console.error(e);
                element.remove();
            });
    },
}));
